import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { App } from "@capacitor/app";
import { DEEPLINK_SENTINEL_PARAM } from "../../util/storeUtils";

const AppUrlListener = () => {
  let navigate = useNavigate();

  useEffect(() => {
    App.addListener("appUrlOpen", (event) => {
      console.log("🔗 Deep link received:", event.url);

      let cleanedUrl = event.url;

      try {
        const parsed = new URL(event.url);
        if (parsed.searchParams.has(DEEPLINK_SENTINEL_PARAM)) {
          parsed.searchParams.delete(DEEPLINK_SENTINEL_PARAM);
          cleanedUrl = parsed.toString();
        }
      } catch (error) {
        console.warn("🔗 Unable to parse incoming URL", error);
      }

      let url;
      if (cleanedUrl.includes("/app")) {
        const path = cleanedUrl.split("/app").pop();
        const slug = path?.split("#")[1] || "/";
        url = slug;
      } else if (cleanedUrl.startsWith("inyc://")) {
        const path = cleanedUrl.replace("inyc://", "");
        url = path.startsWith("/") ? path : `/${path}`;
      }

      if (!url) {
        return;
      }

      navigate(url);
    });
  }, [navigate]);

  return null;
};

export default AppUrlListener;
